<template>
  <a href="https://www.sailboat.co.jp/recruit/" target="_blank">
    <v-card>
      <v-img :src="BannerImage"></v-img>
    </v-card>
  </a>
</template>

<script>
import BannerImage from "@/assets/banner.png";

export default {
  name: "RecruitBanner",
  data() {
    return {
      BannerImage
    };
  }
};
</script>
